import { useCallback, useRef } from 'react';

export const useThrottle = <T extends unknown[]>(
  callback: (...args: T) => void,
  delay: number,
) => {
  const timeout = useRef<NodeJS.Timeout | undefined>(undefined);

  const throttledCallback = useCallback((...args: T) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    timeout.current = setTimeout(() => {
      callback(...args);
      timeout.current = undefined;
    }, delay);
  }, [ callback, delay ]);

  return throttledCallback;
};
